import { disputeStatus } from "@redotech/redo-dispute-db-schema/dispute-definition";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { bankNameClassification } from "./get-reclaim-disputes";

/**
 * Total count of reclaim disputes matching the same filters as
 * getReclaimDisputes. Split out so the count is fetched independently and
 * cached longer than the page query — paging through results no longer
 * re-runs COUNT(*) every page change.
 */
export const getReclaimDisputesCount = unaryRpc({
  name: "getReclaimDisputesCount" as const,
  input: z.object({
    statuses: z.array(z.enum(disputeStatus)).optional(),
    bankNameClassification: z.enum(bankNameClassification).optional(),
  }),
  output: z.object({ total: z.number().int() }),
});
